import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api, { getToken, setToken, clearToken } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(null); setSubscription(null); setLoading(false); return; }
    try {
      const data = await api.get('/auth/me');
      setUser(data.user);
      setSubscription(data.subscription);
    } catch (e) {
      setUser(null);
      setSubscription(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const data = await api.post('/auth/login', { email, password });
    setToken(data.token);
    await refresh();
    return data.user;
  };

  const register = async (payload) => {
    const ref = localStorage.getItem('yc_ref');
    const data = await api.post('/auth/register', ref ? { ...payload, ref } : payload);
    localStorage.removeItem('yc_ref');
    setToken(data.token);
    await refresh();
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(null);
    setSubscription(null);
  };

  return (
    <AuthContext.Provider value={{ user, subscription, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
